import React, { useEffect, useState } from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import { Box, Grid, Modal, Typography } from '@mui/material';

import { StyledLabel } from '../../components/StyledComponents';
import { connect, useDispatch } from 'react-redux';
import { LetsGoBtn2, LetsGoBtn3 } from '../../components/Buttons';
import { setIsOpenCancelModal } from '../../redux/mainReducer';

import './CancelModal.css';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',

  maxWidth: 900,
  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: '50px 80px 50px 80px',
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function CancelModal({ isOpenModal, func, id }) {
  const [randomPhrase, setRandomPhrase] = useState(0);
  const dispatch = useDispatch();
  const phrases = ['Ви можете відмінити відправку повідомлення, доки користувач не прочитав його.'];
  useEffect(() => {
    setRandomPhrase(Math.floor(Math.random() * phrases.length));
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(setIsOpenCancelModal({ isOpen: false, func: null, id: null }));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_cancel_modal"
      >
        <Box sx={style} className="bonfair_cancel_modal-box">
          <CloseIcon
            className="bonfair_cancel_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenCancelModal({ isOpen: false, func: null, id: null }));
            }}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel className="cancelModal-title-text">
                {/* {translate('bonfair_service_modal')} */}
                {'Відмінити відправку?'}
              </StyledLabel>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 2,
                  fontSize: 16,
                  fontFamily: 'FixelText-Medium',
                  textAlign: 'center',
                  maxWidth: '70%'
                }}
              >
                {`${phrases[randomPhrase]}`}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                margin: '20px auto 0px',
                maxWidth: '540px'
              }}
            >
              <LetsGoBtn3
                size="large"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  func(id);
                  dispatch(setIsOpenCancelModal({ isOpen: false, func: null, id: null }));
                }}
                width={250}
                style={{ textTransform: 'inherit' }}
                text="Видалити"
              />
              <LetsGoBtn2
                marginTop="0"
                size="large"
                onClick={() => {
                  dispatch(setIsOpenCancelModal({ isOpen: false, func: null, id: null }));
                }}
                width={250}
                style={{ textTransform: 'inherit' }}
                text="Залишити"
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale
  };
};
export default connect(mapStateToProps)(CancelModal);
